module.exports = "<sq-login></sq-login>\n";